import PropTypes from 'prop-types';
import styled from 'styled-components';
import H7 from 'UIComponents/elements/headings/H7';
//@ts-expect-error Could not find declaration file for module
import PlainLink from '../../PlainLink';
import ReducedCardWrapper from './subcomponents/ReducedCardWrapper';
import { FLAT_EARTH, LORAX } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
//@ts-expect-error Could not find declaration file for module
import MarketingHubLogo from '../../Icons/ProductIcons/MarketingHubLogo';
//@ts-expect-error Could not find declaration file for module
import SalesHubLogo from '../../Icons/ProductIcons/SalesHubLogo';
//@ts-expect-error Could not find declaration file for module
import OpsHubLogo from '../../Icons/ProductIcons/OpsHubLogo';
//@ts-expect-error Could not find declaration file for module
import ServiceHubLogo from '../../Icons/ProductIcons/ServiceHubLogo';
import UIIcon from 'UIComponents/icon/UIIcon';
import ReducedCardSkeleton from './subcomponents/ReducedCardSkeleton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ContentBox = styled.div.withConfig({
  displayName: "AllCoursesButton__ContentBox",
  componentId: "sc-1osqx1m-0"
})(["padding:0 16px;"]);
const ThumbnailBox = styled.div.withConfig({
  displayName: "AllCoursesButton__ThumbnailBox",
  componentId: "sc-1osqx1m-1"
})(["display:flex;align-items:center;justify-content:center;height:60px;width:60px;border-radius:3px;background-color:", ";"], FLAT_EARTH);
const ThumbnailLogo = styled.div.withConfig({
  displayName: "AllCoursesButton__ThumbnailLogo",
  componentId: "sc-1osqx1m-2"
})(["width:32px;height:32px;display:flex;align-items:flex-end;"]);
const TopicMessage = styled(FormattedReactMessage).withConfig({
  displayName: "AllCoursesButton__TopicMessage",
  componentId: "sc-1osqx1m-3"
})(["text-transform:'lowercase';"]);
const OtherLogo = /*#__PURE__*/_jsx(UIIcon, {
  color: LORAX,
  name: "sprocket",
  size: 32
});
const HubProductLogo = {
  marketing: /*#__PURE__*/_jsx(MarketingHubLogo, {}),
  sales: /*#__PURE__*/_jsx(SalesHubLogo, {}),
  'services-support': /*#__PURE__*/_jsx(ServiceHubLogo, {}),
  'administration-operations': /*#__PURE__*/_jsx(OpsHubLogo, {}),
  other: OtherLogo
};
const AllCoursesButton = ({
  to,
  onClick,
  use,
  tab,
  isLoading
}) => {
  if (isLoading) {
    return /*#__PURE__*/_jsx(ReducedCardSkeleton, {
      use: use
    });
  }
  return /*#__PURE__*/_jsx(PlainLink, {
    onClick: onClick,
    to: to,
    children: /*#__PURE__*/_jsxs(ReducedCardWrapper, {
      use: use,
      children: [/*#__PURE__*/_jsx(ThumbnailBox, {
        children: /*#__PURE__*/_jsx(ThumbnailLogo, {
          children: tab ? HubProductLogo[tab] : OtherLogo
        })
      }), /*#__PURE__*/_jsx(ContentBox, {
        children: /*#__PURE__*/_jsx(H7, {
          className: "m-bottom-0",
          children: tab ? /*#__PURE__*/_jsx(FormattedReactMessage, {
            message: "academyComponents.reducedContentCards.allHubCourses",
            options: {
              hub: /*#__PURE__*/_jsx(TopicMessage, {
                message: `learningCenter.learningTopics.options.${tab}`
              })
            }
          }) : /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyComponents.reducedContentCards.allCourses"
          })
        })
      })]
    })
  });
};
AllCoursesButton.defaultProps = {
  use: 'on-light'
};
AllCoursesButton.propTypes = {
  hub: PropTypes.string,
  isLoading: PropTypes.bool,
  onClick: PropTypes.func,
  to: PropTypes.string,
  use: PropTypes.oneOf(['on-dark', 'on-light'])
};
export default AllCoursesButton;